import { PropsWithChildren } from 'react';
import { Box } from '@bridebook/ui';
import componentStyles from './content-container.style';

export interface ISharedTypes {
  noPaddingTop?: boolean;
  noPaddingBottom?: boolean;
}

interface IProps extends ISharedTypes, PropsWithChildren {}

const ContentContainer = ({ children, noPaddingTop, noPaddingBottom }: IProps) => {
  const styles = componentStyles({ noPaddingTop, noPaddingBottom });

  return <Box style={styles.wrapper}>{children}</Box>;
};

export default ContentContainer;
